import React, { useState, useEffect } from 'react';
import '../../../assets/css/Loading.css';

const FADE_OUT_DELAY_MS = 300;

const Loading = ({ onLoadingComplete, duration = 3000 }) => {
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const startTime = performance.now();
    let animationFrameId;

    const animateProgress = (now) => {
      const elapsed = now - startTime;
      const currentLoaded = window.__loadingImagesLoadedCount || 0;
      const currentTotal = window.__loadingImagesTotal || 1;
      const isApiLoading = window.__experiencesLoaded === false;

      const nextProgress = Math.min((elapsed / duration) * 100, 100);
      setProgress(nextProgress);

      if (elapsed < duration || currentLoaded < currentTotal || isApiLoading) {
        animationFrameId = requestAnimationFrame(animateProgress);
        return;
      }

      setIsComplete(true);
      setTimeout(() => {
        onLoadingComplete();
      }, FADE_OUT_DELAY_MS);
    };

    animationFrameId = requestAnimationFrame(animateProgress);

    // Preload critical images
    const preloadImages = () => {
      let imageUrls = [];
      const currentPath = window.location.pathname;

      if (currentPath === '/reservation') {
        imageUrls = [
          '/images/section6ahome_pottery1.webp',
          '/images/section7ahome_painting2.webp',
          '/images/section8ahome_sailing2.webp',
          '/images/reservationsection3_bicycling1.webp',
          '/images/section6ahome_pottery2.webp',
          '/images/pottery/potterypainting.webp',
          '/images/pottery/potterypainting2.webp',
          '/images/prewed/prewed2.jpg',
        ];
      } else if (currentPath === '/') {
        imageUrls = [
          '/images/section6ahome_pottery1.webp',
          '/images/section7ahome_painting2.webp',
          '/images/about1.webp',
          '/images/prewed/prewed2.jpg',
          '/images/section5ahome_bicycling1.webp',
          '/images/section6ahome_pottery2.webp',
          '/images/section8ahome_sailing2.webp',
          '/images/prewed/prewed1.jpg',
        ];
      } else {
        // default minimal images for booking flow
        imageUrls = [
          '/images/Logo_Alaise-removebg-preview.png'
        ];
      }

      let loadedCount = 0;
      const totalImages = imageUrls.length;

      // Store globally for the animation frame to read
      window.__loadingImagesLoadedCount = 0;
      window.__loadingImagesTotal = totalImages;

      imageUrls.forEach(url => {
        const img = new Image();
        const countLoadedImage = () => {
          loadedCount++;
          window.__loadingImagesLoadedCount = loadedCount;
          // Keep tracking image readiness without forcing progress to end before duration.
          setProgress(prev => Math.max(prev, Math.min((loadedCount / totalImages) * 95, prev)));
        };

        img.onload = countLoadedImage;
        img.onerror = countLoadedImage;
        img.src = url;
      });
    };

    preloadImages();

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [duration, onLoadingComplete]);

  return (
    <div className={`loading-overlay ${isComplete ? 'fade-out' : ''}`}>
      <div className="loading-content">
        {/* Logo */}
        <div className="loading-logo">
          <h1 className="loading-title">À L'AISE</h1>
          <p className="loading-subtitle">BY THE LAKE</p>
        </div>

        {/* Loading Bar */}
        <div className="loading-bar-container">
          <div 
            className="loading-bar" 
            style={{ width: `${Math.min(progress, 100)}%` }}
          ></div>
        </div>

        {/* Progress Text */}
        <div className="loading-text">
          {Math.round(Math.min(progress, 100))}%
        </div>
      </div>
    </div>
  );
};

export default Loading;
